export const colorDataToCSS = (colorData) => {
    if (!colorData) return '#000000'; // fallback solid color
  
    if (colorData.type === 'solid') {
      return colorData.color;
    }
  
    if (colorData.type === 'gradient') {
      const { gradientType = 'linear', color1 = 'rgba(247, 10, 10,1)', color2 = 'rgba(127, 14, 240,1)' } = colorData;
      const direction = gradientType === 'linear' ? '90deg' : 'circle';
  
      return `${gradientType}-gradient(${direction}, ${color1} 0%, ${color2} 100%)`;
    }
  
    return '#000000'; // fallback
  };
  
  export function parseCSSColor(cssColor) {
    if (!cssColor || typeof cssColor !== 'string') {
      return { type: 'solid', color: '#000000' };
    }
  
    if (cssColor.startsWith('linear-gradient') || cssColor.startsWith('radial-gradient')) {
      const colors = cssColor.match(/rgba?\([^)]+\)/g) || [];
      const isLinear = cssColor.startsWith('linear-gradient');
      return {
        type: 'gradient',
        gradientType: isLinear ? 'linear' : 'radial',
        color1: colors[0] || 'rgba(235, 19, 19,1)',
        color2: colors[1] || colors[0] || 'rgba(112, 29, 228,1)',
      };
    }
  
    return {
      type: 'solid',
      color: cssColor,
    };
  }
  export function parseGradientColors (gradientString) {
    const regex = /rgba?\([^)]+\)/g;
    const matches = gradientString.match(regex);
  
    if (matches && matches.length >= 2) {
      return {
        color1: matches[0],
        color2: matches[1]
      };
    } else {
      // fallback if parsing fails
      return {
        color1: '#E31818',
        color2: '#D531CE'
      };
    }
  };
    
export function getRandomColor(randOpp = false) {
  const r = () => Math.floor(Math.random() * 256);
  const o = randOpp ? +(Math.random() * 0.5 + 0.5).toFixed(2) : 1;
  return `rgba(${r()},${r()},${r()},${o})`;
};